"use client";
function e({children:e}){return e}export{e as default};
